import gql from "graphql-tag"

export default gql`
  mutation ($daysInactive: Int!) {
    removeAccessForInactiveMembers(daysInactive: $daysInactive)
  }
`
